/**
 * Represents a measure value with current and historical data points.
 * Includes the current value, values from 7, 30, and 90 days ago,
 * and the absolute and percentage changes over those periods.
 */
export type MeasureValue = {
    val: number;
    val_7d: number | null;
    val_30d: number | null;
    val_90d: number | null;
    chg_7d_amt: number | null;
    chg_7d_pct: number | null;
    chg_30d_amt: number | null;
    chg_30d_pct: number | null;
    chg_90d_amt: number | null;
    chg_90d_pct: number | null;
} | null;

export enum DistributionTypes {
    Distributed = "distributed",
    Represented = "represented",
    All = "all",
}

export type DistributionType = "distributed" | "represented" | "all";

// // // //

// ENHANCEMENT - move column span config + the CSS function into a dedicated file for re-use in more places
type ColumnSpans = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export interface ColumnSpanConfig {
    sm?: ColumnSpans;
    md?: ColumnSpans;
    lg?: ColumnSpans;
    xl?: ColumnSpans;
    xxl?: ColumnSpans;
}
